import Subscription from './SubscriptionContainer';

export default Subscription;
